import QualityComponent from './index.js'

if (!window.AliPlayerComponent) {
  window.AliPlayerComponent = {}
}
window.AliPlayerComponent.QualityComponent = QualityComponent



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/QualityComponent/export.js